






























































































































































import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  computed,
} from '@vue/composition-api'
import MediaItem from '@/views/dashboard/components/media/MediaItem/MediaItem.vue'
import ChangePageMenu from '@/views/dashboard/components/media/ChangePageMenu.vue'
import draggable from 'vuedraggable'
import { MediaItemOccurence, CategoryGroup } from '@/shared/types'
import { sortByOrder, reorderArray } from '@/shared/utils'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { mediaItemFileLink } from '@/shared/api'
import {
  EDIT_MEDIA_ITEM_OCCURENCE,
  DELETE_MEDIA_ITEM_OCCURENCE,
  REORDER_MEDIA_ITEM_OCCURENCES,
} from '@/shared/user/permissions'

export default defineComponent({
  name: 'TextbookIssuePage',
  components: {
    MediaItem,
    draggable,
    ChangePageMenu,
  },
  props: {
    textbookIssuePageMediaElements: Array,
    loading: Boolean,
    page: Number,
    textbookIssue: Object,
    selectedMediaItems: Array,
  },
  setup(props, { root, emit }) {
    const { hasPermissionTo } = useUserStore().getters
    const data = reactive({
      headers: [
        {
          text: root.$t('textbookIssuePage.headers.preview'),
          value: 'preview',
          sortable: false,
        },
        {
          text: root.$t('textbookIssuePage.headers.filename'),
          value: 'filename',
          sortable: false,
        },
        {
          text: root.$t('textbookIssuePage.headers.name'),
          value: 'name',
          sortable: false,
        },
        // {
        //   text: root.$t('textbookIssuePage.headers.status'),
        //   value: 'status',
        // },
        // {
        //   text: root.$t('textbookIssuePage.headers.category'),
        //   value: 'category',
        // },
        {
          text: root.$t('textbookIssuePage.headers.licenses'),
          value: 'licenses',
          sortable: false,
        },
        {
          text: root.$t('textbookIssuePage.headers.downloadable'),
          value: 'isDownloadable',
          sortable: false,
        },
        {
          text: 'Aktionen',
          value: 'actions',
          sortable: false,
        },
      ],
      search: undefined,
    })

    const draggedId = ref(null)
    const closedCategories = ref([])
    const occurencesGroupedByCategory = computed(() =>
      sortByOrder(
        Object.values(
          (props.textbookIssuePageMediaElements as MediaItemOccurence[]).reduce(
            (acc: { [key: string]: CategoryGroup }, el: MediaItemOccurence) => {
              const id = el.category ? el.category.id : 'nocategory'
              if (!el.category) {
                if (!(id in acc)) {
                  acc[id] = {
                    id,
                    name: root.$t(
                      'textbookIssuePage.noCategoryLabel'
                    ) as string,
                    order: null,
                    occurences: [] as Array<MediaItemOccurence>,
                  }
                }
              } else if (!(el.category.id in acc)) {
                acc[id] = {
                  id,
                  name: el.category.name,
                  order: el.category.order,
                  occurences: [] as Array<MediaItemOccurence>,
                }
              }
              acc[id].occurences.push(el)
              return acc
            },
            {} as { [key: string]: CategoryGroup }
          )
        ).map((el: CategoryGroup) => ({
          ...el,
          occurences: sortByOrder(el.occurences),
        }))
      )
    )

    const toggleCategory = (categoryId: string) => {
      if (closedCategories.value.includes(categoryId)) {
        closedCategories.value.forEach((el: string, index: number) => {
          if (el === categoryId) {
            closedCategories.value.splice(index, 1)
          }
        })
        return
      }

      closedCategories.value.push(categoryId)
    }

    const reorderMediaElements = (
      categoryId: string,
      oldIndex: number,
      newIndex: number
    ) => {
      if (newIndex === oldIndex) {
        return
      }

      // const oldArray = occurencesGroupedByCategory.value.reduce((acc, el) => [...acc, ...el.occurences], [])
      const categoryGroup = occurencesGroupedByCategory.value
        .filter((el) => el.id === categoryId)
        .pop()
      categoryGroup.occurences = reorderArray(
        categoryGroup.occurences,
        oldIndex,
        newIndex
      )
      const newArray = occurencesGroupedByCategory.value
        .reduce(
          (acc, el) =>
            el.id === categoryId
              ? [...acc, ...categoryGroup.occurences]
              : [...acc, ...el.occurences],
          []
        )
        .map((el, index) => ({ ...el, order: index + 1 }))
      emit('reorder-media-elements', newArray)
    }

    const deleteSelected = async () => {
      emit('delete-selected')
    }

    return {
      deleteSelected,
      ...toRefs(data),
      draggedId,
      occurencesGroupedByCategory,
      closedCategories,
      toggleCategory,
      reorderMediaElements,
      hasPermissionTo,
      EDIT_MEDIA_ITEM_OCCURENCE,
      DELETE_MEDIA_ITEM_OCCURENCE,
      REORDER_MEDIA_ITEM_OCCURENCES,
      mediaItemFileLink,
    }
  },
})
